"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMBO_NO_PROTECTION_DAYS_THRESHOLD = exports.COMBO_LONGEST_PROTECTION_DAYS_THRESHOLD = exports.DEFAULT_ACCOMODATION_COST = exports.MAX_ACCOMODATION_COST = exports.MIN_ACCOMODATION_COST = exports.MAX_COMBO_DISCOUNT_COEFFICIENT = exports.MIN_COMBO_DISCOUNT_COEFFICIENT = exports.MAX_COMBO_ENGINE_RANGE_DAYS = exports.LOOSEN_COMBO_LOCK_FOR_EARLY_OFFERS_DAYS = exports.COMBO_REPLACEMENT_TRIP_LOOKUP_DAYS = exports.AUTO_POSTED_COMBO_TYPES = exports.CLEAN_COMBO_TYPES = exports.COMBO_REVIEW_DISCARD_REASONS = exports.COMBO_REVIEW_DISCARD_REASON_ERROR = exports.COMBO_REVIEW_DISCARD_REASON_OVERBOOKING = exports.COMBO_REVIEW_DISCARD_REASON_NOT_ACCEPTED = void 0;
exports.COMBO_REVIEW_DISCARD_REASON_NOT_ACCEPTED = "Offer was not accepted";
exports.COMBO_REVIEW_DISCARD_REASON_OVERBOOKING = "Driver is busy/overbooked";
exports.COMBO_REVIEW_DISCARD_REASON_ERROR = "Failed to post the offer automatically";
exports.COMBO_REVIEW_DISCARD_REASONS = [
    "Combo no longer exists",
    exports.COMBO_REVIEW_DISCARD_REASON_OVERBOOKING,
    exports.COMBO_REVIEW_DISCARD_REASON_NOT_ACCEPTED,
    "Waiting time is too short",
    "Locked combo is missing a replacement trip",
    "Driver didn't accept a replacement for locked combo",
    "Driver coverage is insufficient",
    "Other",
];
exports.CLEAN_COMBO_TYPES = ["Clean", "CleanMultiday"];
exports.AUTO_POSTED_COMBO_TYPES = ["Clean", "CleanMultiday", "Personal", "PersonalMultiday"];
exports.COMBO_REPLACEMENT_TRIP_LOOKUP_DAYS = 40;
exports.LOOSEN_COMBO_LOCK_FOR_EARLY_OFFERS_DAYS = 1;
exports.MAX_COMBO_ENGINE_RANGE_DAYS = 90;
exports.MIN_COMBO_DISCOUNT_COEFFICIENT = 0.2;
exports.MAX_COMBO_DISCOUNT_COEFFICIENT = 2;
exports.MIN_ACCOMODATION_COST = 5;
exports.MAX_ACCOMODATION_COST = 1000;
exports.DEFAULT_ACCOMODATION_COST = 50;
// System should never wait for new combos longer than 10 days before departure
exports.COMBO_LONGEST_PROTECTION_DAYS_THRESHOLD = 10;
exports.COMBO_NO_PROTECTION_DAYS_THRESHOLD = 28;
//# sourceMappingURL=combo.js.map